import {
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import { useState } from "react";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import Card from "../../../components/Card";
import { getTranslation } from "../../../heplers/translationHelper";
import ButtonWithLoading from "../../../components/ButtonWithLoading";
import { MyDialog } from "../../../components/Dialog";
import { Get_SystemSetting_URL, Upsert_Customers_URL } from "../../../constants/apiUrls";
import { Get, Post } from "../../../actions";
import { CountrySelection } from "../../../constants/countries";

const AddUser = ({
  formData,
  open,
  onSubmit,
  onClose
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [systemSetting, setSystemSetting] = useState({});

  const addValidationSchema = Yup.object().shape({
    firstName: Yup.string().required(getTranslation("First Name is required")),
    lastName: Yup.string().required(getTranslation("Last Name is required")),
    email: Yup.string().required(getTranslation("Username is required"))
    .test(
      'no-at-symbol',
      getTranslation("Do not include \"@\" in the username"),
      (value) => !value || !value.includes('@')
    ),
	  password: Yup.string()
	  .min(8, getTranslation("Password atleast 6 character long"))
	  .required(getTranslation("Password is required")),
	confirmPassword: Yup.string()
	  .min(8, getTranslation("Password atleast 6 character long"))
	  .oneOf([Yup.ref("password"), null], getTranslation("Passwords must match")),
  });

  const updateValidationSchema = Yup.object().shape({
    firstName: Yup.string().required(getTranslation("First Name is required")),
    lastName: Yup.string().required(getTranslation("Last Name is required")),
    email: Yup.string().required(getTranslation("Username is required"))
    .test(
      'no-at-symbol',
      getTranslation("Do not include \"@\" in the username"),
      (value) => !value || !value.includes('@')
    ),
  });

  useEffect(() => {
    getSystemSetting();
  }, []);


  const [roles,setRoles]=useState("")
  useEffect(() => {
    if (formData?.id) {
      Get(
        { id: formData.id },
        "RestaurantUsers/GetUserRoles",
        null,
        (resp) => {
          setRoles(resp.data && resp.data[0] ? resp.data[0] : "Staff");
        },
        (error) => {
          console.error("API Error:", error);
        }
      );
    }
  }, [formData]);
  console.log("formData:", formData);

  

  const getSystemSetting = () => {
    Get(
      {},
      Get_SystemSetting_URL,
      null,
      (res) => {
        setSystemSetting(res?.data);
      },
      (err) => {
        enqueueSnackbar(
          err.data
            ? getTranslation(err.data, err.data, err.data)
            : getTranslation(
                "Something went wrong. Please contact with admin.",
                "Something went wrong. Please contact with admin.",
                "Something went wrong. Please contact with admin."
              ),
          {
            variant: "error",
          }
        );
      }
    );
  };
  // const submit = async (data, actions) => {
  //   actions.setSubmitting(true);
  
  //   try {
  //     const response = await Post(data, Upsert_Customers_URL);
  //     actions.setSubmitting(false);
      
  //     enqueueSnackbar(
  //       formData
  //         ? getTranslation("Updated successfully")
  //         : getTranslation("Customer created successfully"),
  //       { variant: "success" }
  //     );
  
  //     onClose(); 
  //     fetchUsers(); // Refresh the user list after adding/editing
  //   } catch (err) {
  //     actions.setSubmitting(false);
  //     enqueueSnackbar(
  //       err?.data || getTranslation("Something went wrong. Please try again"),
  //       { variant: "error" }
  //     );
  //   }
  // };
  
const defaultData={
	firstName: "",
	lastName: "",
	email: "",
	password:"",
	confirmPassword:"",
  role: roles?roles: "Staff"
  }
  return (
    <MyDialog
      title={
        formData
          ? getTranslation("Edit User", "Edit User", "Edit User")
          : getTranslation("Add User", "Add User", "Add User")
      }
      onClose={onClose}
      open={open}
    >
      <Card>
        <CardContent>
        <Formik
  initialValues={
    formData 
      ? { ...formData, role: roles || "Staff", email: formData.email.split("@")[0] } 
      : defaultData
  }
  enableReinitialize
  validationSchema={formData ? updateValidationSchema : addValidationSchema}
  onSubmit={onSubmit}
>

            {({
              values,
              errors,
              touched,
              handleChange,
              setFieldValue,
              handleSubmit,
              handleBlur,
              resetForm,  
              isSubmitting,
            }) => {
              
              return (
                <Form>
                  {console.log("kjaslhdkjaskdd",values)}
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation(
                          "First Name",
                          "First Name",
                          "First Name"
                        )}
                        name="firstName"
                        type="string"
                        size="small"
                        value={values.firstName}
                        onChange={handleChange}
                        error={touched.firstName && Boolean(errors.firstName)}
                        helperText={touched.firstName && errors.firstName}
                        
                      />
                    </Grid>
                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation(
                          "Last Name",
                          "Last Name",
                          "Last Name"
                        )}
                        name="lastName"
                        type="string"
                        size="small"
                        value={values.lastName}
                        onChange={handleChange}
                        error={touched.lastName && Boolean(errors.lastName)}
                        helperText={touched.lastName && errors.lastName}
                     
                      />
                    </Grid>
                    <Grid item sm={12} md={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        label={getTranslation("Email", "Email", "Email")}
                        name="email"
                        type="string"
                        size="small"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.email && Boolean(errors.email)}
                        helperText={touched.email && errors.email}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <span
                                style={{ fontWeight: "bold", color: "#666" }}
                              >
                                @{systemSetting.website}
                              </span>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
             
                    {formData == null ? (
                      <>
                        <Grid item sm={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            type="password"
                            label={getTranslation(
                              "Password",
                              "Mot de passe",
                              "Passwort"
                            )}
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            error={touched.password && Boolean(errors.password)}
                            helperText={touched.password && errors.password}
                          />
                        </Grid>
                        <Grid item sm={12} md={12} lg={12}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            type="password"
                            label={getTranslation(
                              "Confirm Password",
                              "Confirmer le mot de passe",
                              "Passwort bestätigen"
                            )}
                            name="confirmPassword"
                            value={values.confirmPassword}
                            onChange={handleChange}
                            error={
                              touched.confirmPassword &&
                              Boolean(errors.confirmPassword)
                            }
                            helperText={
                              touched.confirmPassword && errors.confirmPassword
                            }
                          />
                        </Grid>
                      </>
                    ) : null}
                <Grid item xs={12} sm={12} md={12}>
                <FormControl variant="outlined" fullWidth>
  <InputLabel id="role-select-label">
    {getTranslation("Role", "Role", "Rolle")}
  </InputLabel>
  <Select
    labelId="role-select-label"
    id="role-select"
    value={values.role || "Staff"}
    onChange={(e) => setFieldValue("role", e.target.value)}
    label={getTranslation("Role", "Role", "Rolle")} 
  >
    <MenuItem value="Manager">
      {getTranslation("Manager", "Manager", "Manager")}
    </MenuItem>
    <MenuItem value="ZCash">
      {getTranslation("Z-Cash", "Z-Cash", "Z-Cash")}
    </MenuItem>
    <MenuItem value="Staff">
      {getTranslation("Staff", "Staff", "Staff")}
    </MenuItem>
  </Select>
</FormControl>

</Grid>

                    <Grid item sm={12} md={12}>
                      <ButtonWithLoading
                        type="submit"
                        loading={isSubmitting}
                        onClick={handleSubmit}
                        title={
                          formData
                            ? getTranslation("Update", "Update", "Update")
                            : getTranslation("Add", "Add", "Add")
                        }
                        variant="contained"
                        color="primary"
                        textColor="white"
                      />
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </CardContent>
      </Card>
    </MyDialog>
  );
};

export default AddUser;
